import { Component } from '@angular/core';

@Component({
  selector: 'ngx-configs-widget',
  templateUrl: './configs-widget.component.html',
  styleUrls: ['./configs-widget.component.scss']
})
export class ConfigsWidgetComponent {
  constructor(){}
}
